import React from 'react';
import { STYLES } from './constants';
import { NoAttachment } from './noAttachment';
import { HasAttachment } from './hasAttachment';

interface IProps {
  documentId: string;
  billId: string;
  billStatus: string;
}
const PreviewAddAttachment = ({ documentId, billId, billStatus } : IProps) => (
  <div className={STYLES.WRAPPER} data-testid='billsHub_attachment'>
    {documentId ? (<HasAttachment documentId={documentId} />) : (<NoAttachment billId={billId} billStatus={billStatus} />)}
  </div>
);
export default PreviewAddAttachment;
